/**
 * Catalog of free-tier / open models available per modality.
 * Hugging Face's free `hf-inference` provider only serves a small curated set,
 * so these are chosen for free availability. If one says "not on the free tier"
 * pick another — HF rotates which models are "warm".
 */

export const IMAGE_MODELS = [
  {
    value: 'black-forest-labs/FLUX.1-schnell',
    label: 'FLUX.1 schnell',
    description: 'Fast, high quality, free. Best default.',
    badge: 'FLUX',
  },
];

export const MUSIC_MODELS = [
  {
    value: 'facebook/musicgen-small',
    label: 'MusicGen Small',
    description: 'Text-to-music. Limited on HF free tier.',
    badge: 'Meta',
  },
];

export const CODE_MODELS = [
  {
    value: 'llama-3.1-8b-instant',
    label: 'Llama 3.1 8B Instant',
    description: 'Fast & free. Best default.',
    badge: 'Groq',
  },
  {
    value: 'llama-3.3-70b-versatile',
    label: 'Llama 3.3 70B',
    description: 'Higher quality, still free.',
    badge: 'Groq',
  },
  {
    value: 'gemma2-9b-it',
    label: 'Gemma2 9B',
    description: 'Google, lightweight.',
    badge: 'Groq',
  },
];

export const ASPECT_RATIOS = [
  { value: '1:1', label: 'Square', w: 1024, h: 1024 },
  { value: '16:9', label: 'Wide', w: 1344, h: 768 },
  { value: '9:16', label: 'Tall', w: 768, h: 1344 },
  { value: '4:3', label: 'Classic', w: 1152, h: 896 },
  { value: '3:2', label: 'Photo', w: 1216, h: 832 },
];

export const CODE_LANGUAGES = [
  { value: 'javascript', label: 'JavaScript' },
  { value: 'typescript', label: 'TypeScript' },
  { value: 'python', label: 'Python' },
  { value: 'java', label: 'Java' },
  { value: 'go', label: 'Go' },
  { value: 'rust', label: 'Rust' },
  { value: 'cpp', label: 'C++' },
  { value: 'csharp', label: 'C#' },
  { value: 'sql', label: 'SQL' },
  { value: 'bash', label: 'Bash' },
];
